
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";

class FavoritesGamesList extends Component {
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

export default FavoritesGamesList;